/* prettier-ignore */

import { Component, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { catchError, combineLatest, EMPTY, filter, take } from 'rxjs';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { SendUpdateRouteService } from 'src/app/pages/send-update-route/send-update-route.service';
import { AppDataService } from 'src/app/services/appData.service';
import { AuthService } from 'src/app/auth/services';
import { DebugService } from 'src/app/services/debug.service';
import { RestService } from 'src/app/services/rest.service';
import { ToolsService } from 'src/app/services/tools.service';
import { UserService } from 'src/app/user/services';
import Swal from "sweetalert2";

@Component({
  selector: 'cicerone-route-card',
  templateUrl: './route-card.component.html',
  styleUrls: ['./route-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RouteCardComponent {
    @Input('isSaveRoute') isSaveRoute?: boolean = false;
    @Input() item?: any;
    private debugService = inject(DebugService);
    private sendUpdateService = inject(SendUpdateRouteService);

    constructor(
      private router: Router,
      public translate: TranslateService, 
      public rest: RestService, 
      public tools: ToolsService,
      public userService: UserService,
      public authService: AuthService,
      private routeService: NewCustomRouteService,
      public appData: AppDataService
    ) { }

    private initializeData(item) {
      combineLatest([this.routeService.registerOptions$, this.routeService.routeItems$]).pipe(
          filter(([registerOptions, routeItems]) => registerOptions !== null && routeItems !== null), 
          take(1)
      ).subscribe(() => {
          this.goToRoute(item)
      });
    }

    handleClick(item){
      if (this.isSaveRoute) return;
      this.tools.enableSpinner();     
      this.routeService.initializeData();
      this.initializeData(item);
    }

    goToRoute(item){
      if (this.tools.isDistributor){
        this.rest.getRouteDistributor(item.id).subscribe(data => {
          this.setRouteInfo(data?.cicerone)
          const route = data.cicerone?.route ? JSON.parse(data.cicerone.route) : [];
          const mappedRoute = this.routeService.mapRouteStructure(route);
          this.debugService.info(mappedRoute, '[RouteCardComponent] Mapped DISTRIBUTOR Route');

          this.routeService.isRecommendedRoute.set(true)
          this.routeService.route.set(mappedRoute);
          this.routeService.filterDistributorItems();
          this.tools.disableSpinner();
          this.router.navigateByUrl('/register-user');
        })
        return;
      }

      this.rest.getRoute(item.id).subscribe(data => {
        this.setRouteInfo(data?.cicerone);
        const route = data.cicerone?.route ? JSON.parse(data.cicerone.route) : [];
        const mappedRoute = this.routeService.mapRouteStructure(route);
        this.debugService.info(mappedRoute, '[RouteCardComponent] Mapped APP Route');
        
        this.routeService.isRecommendedRoute.set(true)
        this.routeService.route.set(mappedRoute);
        this.routeService.filterAppItems();
        this.tools.disableSpinner();
        this.router.navigateByUrl('/register-user');
      })
    }

    setRouteInfo(response){
      this.sendUpdateService.item.update(prev => ({...prev, id: response.id, route_days: response.route_days}))
      if (response.image && response.image !== '')
        this.sendUpdateService.item.update(prev => ({...prev, image: response.image}))

      if (response.name && response.name !== '' && Object.values(response.name)?.some(value => value && value !== ''))
        this.sendUpdateService.item.update(prev => ({...prev, name: response.name}))
    }

    isFavourite(item){
      return this.userService.favouritesRoutes.includes(item.id)
    }

    setFavourite(item){
      if (this.isSaveRoute) 
        return;

      if (!this.authService.user()){
        this.userService.login();
        return;
      }

      const foundRoute = this.userService.favouritesRoutes.find(route => route == item.id);
      if (foundRoute){
        this.userService.favouritesRoutes = this.userService.favouritesRoutes.filter(route => route != foundRoute)
        this.userService.removeFavouriteRoute(item.id).subscribe(res => { this.debugService.debug(res, `[RouteCardComponent] Route ${item.id} remove from favourites`) })
      } 
      else {
        this.userService.addFavouriteRoute(item.id)
        .pipe(
          catchError(error => {
            this.debugService.debug(error, `[GenericCardComponent] Error adding event ${item.id} to favourites`);
            this.userService.showErrorSwalFavourtives();
            return EMPTY; 
          })
        )
        .subscribe(res => { 
          this.debugService.debug(res, `[RouteCardComponent] Route ${item.id} added to favourites`);
          this.userService.favouritesRoutes.push(item.id)
          this.userService.showSuccessSwalFavourtives();
        })
      }
    }

    removeItem(item) {
      Swal.fire({
        title: this.translate.instant(`¿Quieres eliminar`) + item?.name?.[this.translate.currentLang] + '?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonColor: "#ff0000",
        cancelButtonColor: "#000000",
        confirmButtonText: this.translate.instant("Eliminar"),
        cancelButtonText: this.translate.instant(`Cancelar`),
        reverseButtons: true,
        scrollbarPadding: false
      }).then((result) => {
        if (result.isConfirmed){
          this.rest.disableRecommendedRoute(item?.id).subscribe(res => {
            this.appData.dataHome.routes = this.appData?.dataHome?.routes?.filter(route => route != item);
            Swal.fire({
                title: '',
                text: this.translate.instant('Ruta eliminada correctamente'),
                icon: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
            })

          })
        }
      });
    }

}